export * from './AcademyDetailTag';
